<div class="content-header flex-c a-center">
    <div class="font--brand">{{ I18nKeyEnum.LANDING_PAGE_TOP_ROW | i18n | async }}</div>
    <div class="font--headline">{{ I18nKeyEnum.LANDING_PAGE_TITLE | i18n | async }}</div>
    <div class="font">{{ I18nKeyEnum.LANDING_PAGE_INFO | i18n | async }}</div>
</div>
<mat-expansion-panel hideToggle expanded *ngIf="!crawlingInitialized">
    <div class="panel-title">
        <div class="font">{{ I18nKeyEnum.ENTER_YOUR_WEBSITE | i18n | async }}</div>
    </div>
    <form class="flex-r a-center" [formGroup]='websiteForm'>
        <mat-form-field class="grow">
            <mat-label>{{ I18nKeyEnum.WEBSITE | i18n | async }}</mat-label>
            <input [required]="true"
                   [formControl]="websiteCtrl"
                   matInput>
            <mat-error
                    *ngIf="websiteCtrl.hasError(validatorsErrorEnum.REQUIRED)"
            > {{ I18nKeyEnum.ERROR_REQUIRED | i18n | async }}
            </mat-error>
        </mat-form-field>
        <button mat-flat-button class="button-base m-left" type="button"
                (click)="initCrawling()">{{ I18nKeyEnum.START | i18n | async }}
        </button>
    </form>
    <div class="frc-captcha flex-r" #captcha></div>
    <mat-error class="no-human-error"
               *ngIf="captchaCtrl.hasError(validatorsErrorEnum.REQUIRED) && !captchaCtrl.untouched"
    > {{ I18nKeyEnum.NO_HUMAN_ERROR | i18n | async }}
    </mat-error>
</mat-expansion-panel>

<mat-expansion-panel hideToggle expanded *ngIf="crawlingInitialized">
    <div class="font m-bottom-mid m-top-big">{{ I18nKeyEnum.YOUR_WEBSITE | i18n | async }}</div>
    <div class="font m-left-big m-bottom-mid">{{ websiteCtrl.value }}</div>
    <form class="flex-r m-top-big" [formGroup]='freeTrialForm'>
        <div>
            <div class="font m-bottom-mid">{{ I18nKeyEnum.YOUR_EMAIL| i18n | async  }}</div>
            <mat-form-field class="min-300">
                <mat-label>{{ I18nKeyEnum.EMAIL| i18n | async }}</mat-label>
                <input [required]="true"
                       [formControl]="firstNameCtrl"
                       matInput>
                <mat-error
                        *ngIf="firstNameCtrl.hasError(validatorsErrorEnum.REQUIRED)"
                > {{ I18nKeyEnum.ERROR_LAST_NAME_REQUIRED | i18n | async }}
                </mat-error>
            </mat-form-field>
        </div>
       <div class="m-left-big">
           <div class="font m-bottom-mid">{{ I18nKeyEnum.YOUR_PHONE| i18n | async  }}</div>
           <div class="flex-r">
               <mat-form-field class="select-country-ct small d m-right-small">
                   <mat-label>{{ I18nKeyEnum.COUNTRY | i18n | async }}</mat-label>
                   <mat-select
                           [required]="true"
                           (selectionChange)="validatePhoneNumber()"
                           id="selectPhoneCountry"
                           [formControl]="countryPrefixCtrl">
                       <mat-select-trigger>
                           <div class="option-wrapper">
                        <span class="country-img">
                            <img *ngIf="!!countryPrefixCtrl.value"
                                 [alt]="countryPrefixCtrl.value.countryCode2"
                                 [src]="countryPrefixCtrl.value.countryCode2 | countryFlagApi"
                                 class="flag-img">
                        </span>
                               <span>
                            {{ countryPrefixCtrl.value.countryPrefix }}
                        </span>
                           </div>
                       </mat-select-trigger>
                       @for (country of countries; track country) {
                           <mat-option [value]="country">
                               <div class="listed-countries">
                                   <div class="pref-img">
                                       <img [alt]="country.countryCode2"
                                            [src]="country.countryCode2 | countryFlagApi"
                                            class="flag-img">
                                   </div>
                                   <div>{{ country.name }}</div>
                                   <div class="pref-code">{{ country.countryPrefix }}</div>
                               </div>
                           </mat-option>
                       }
                   </mat-select>
                   <mat-error
                           *ngIf="countryPrefixCtrl.hasError(validatorsErrorEnum.REQUIRED)"
                   >{{ I18nKeyEnum.ERROR_NUMBER_REQUIRED | i18n | async }}
                   </mat-error>
               </mat-form-field>
               <mat-form-field class="phone-number">
                   <mat-label>{{ I18nKeyEnum.NUMBER | i18n | async }}</mat-label>
                   <input
                           (blur)="validatePhoneNumber()"
                           maxlength="50"
                           required
                           type="tel"
                           matInput
                           id="callbackPhoneNumber"
                           name="callbackPhonenumber"
                           [formControl]="nationalNumberCtrl"
                   >
                   <mat-error
                           *ngIf="nationalNumberCtrl.hasError(validatorsErrorEnum.INVALID_NUMBER)"
                   >{{ I18nKeyEnum.ERROR_INVALID_NUMBER | i18n | async }}
                   </mat-error>
                   <mat-error
                           *ngIf="nationalNumberCtrl.hasError(validatorsErrorEnum.REQUIRED)"
                   >{{ I18nKeyEnum.ERROR_NUMBER_REQUIRED | i18n | async }}
                   </mat-error>
               </mat-form-field>
           </div>
       </div>
    </form>
    <div class="flex-r m-top-mid">
        <div class="font--subtitle--small self-align-end">{{ I18nKeyEnum.DSGVO | i18n | async }}</div>
        <button mat-flat-button class="button-base m-left-big"
                (click)="initAccount()">{{ I18nKeyEnum.LETS_START | i18n | async }}
        </button>
    </div>
</mat-expansion-panel>
<div class="landing-page-no-payment flex-c a-center font-subtitle">{{ I18nKeyEnum.LANDING_PAGE_NO_PAYMENT | i18n | async }}</div>
